// Heuristics + formatting helpers for the recursive content editor.
export const looksLikeImageUrl = (s) =>
  typeof s === "string" &&
  (/\.(jpg|jpeg|png|webp|gif|svg|avif)(\?|$)/i.test(s) ||
    s.includes("images.unsplash.com") ||
    s.includes("squarespace-cdn.com") ||
    s.includes("emergentagent.com") ||
    s.startsWith("/api/media/"));

export const looksLikeVideoUrl = (s) =>
  typeof s === "string" && /\.(mp4|webm|mov|ogg)(\?|$)/i.test(s);

export const looksLikeImageKey = (k) => /image|logo|photo|thumbnail|avatar|cover|heroimage|^src$/i.test(k);
export const looksLikeDocKey = (k) => /fileurl|menuurl|menufile|pdfurl|docurl|attachment/i.test(k);
export const looksLikeVideoKey = (k) => /video|clip|reel/i.test(k);
export const looksLikeMapUrlKey = (k) => /mapurl/i.test(k);
export const looksLikeMultiline = (s) => typeof s === "string" && (s.length > 90 || s.includes("\n"));

export const humanize = (k) =>
  k
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
